import { useQuery } from '@tanstack/react-query'

import { getFrontChatIdentity } from '@/api/front-chat/get-front-chat-identity'
import useAuth from '@/hooks/useAuth'

function useFrontChatIdentity() {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['front-chat-identity', user?.email],
    queryFn: getFrontChatIdentity,
    enabled: !!user?.email,
    staleTime: Infinity,
    retry: false,
  })
}

export { useFrontChatIdentity }
